import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_3 = { class: "items-center justify-between flex flex-shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-row-reverse gap-3" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "mt-5 card w-full h-full flex flex-col min-h-0 mapping-tabs-shell flex-1" }
const _hoisted_10 = { class: "px-5 pb-3 flex-1 min-h-0 flex flex-col" }
const _hoisted_11 = { class: "pt-5" }
const _hoisted_12 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_13 = {
  key: 0,
  class: "noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane"
}
const _hoisted_14 = { class: "ResponsivetableCornerRadius bg-white table-container kpi-table-scroll" }
const _hoisted_15 = { class: "main-table" }
const _hoisted_16 = { class: "table-header-row" }
const _hoisted_17 = { class: "w-12 bg-white" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_38 = ["colspan"]
const _hoisted_39 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "cursor-pointer rowHeight" }
const _hoisted_42 = ["colspan"]
const _hoisted_43 = {
  key: 2,
  class: "tbodylast"
}
const _hoisted_44 = ["onChange", "value"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "overflow-hidden table-ellipsis" }
const _hoisted_48 = { class: "inline" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "pl-6" }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { class: "pl-6" }
const _hoisted_57 = { key: 4 }
const _hoisted_58 = { class: "pl-6" }
const _hoisted_59 = { key: 5 }
const _hoisted_60 = { class: "pl-6" }
const _hoisted_61 = { key: 6 }
const _hoisted_62 = { class: "overflow-hidden table-ellipsis" }
const _hoisted_63 = { class: "inline" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 1,
  class: "noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane"
}
const _hoisted_66 = { class: "ResponsivetableCornerRadius bg-white table-container kpi-table-scroll" }
const _hoisted_67 = { class: "main-table" }
const _hoisted_68 = { class: "table-header-row" }
const _hoisted_69 = {
  key: 0,
  class: ""
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }
const _hoisted_74 = { key: 3 }
const _hoisted_75 = { key: 4 }
const _hoisted_76 = { key: 5 }
const _hoisted_77 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = ["value"]
const _hoisted_81 = ["value"]
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = ["value"]
const _hoisted_84 = ["value"]
const _hoisted_85 = { key: 2 }
const _hoisted_86 = ["onUpdate:modelValue"]
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_89 = ["colspan"]
const _hoisted_90 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "cursor-pointer rowHeight" }
const _hoisted_93 = ["colspan"]
const _hoisted_94 = {
  key: 2,
  class: "tbodylast"
}
const _hoisted_95 = { class: "flex items-center" }
const _hoisted_96 = ["value", "onChange"]
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { class: "overflow-hidden table-ellipsis" }
const _hoisted_99 = { class: "inline" }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { class: "pl-6" }
const _hoisted_102 = { key: 2 }
const _hoisted_103 = { class: "pl-6" }
const _hoisted_104 = { key: 3 }
const _hoisted_105 = { class: "pl-6" }
const _hoisted_106 = { key: 4 }
const _hoisted_107 = { class: "pl-6" }
const _hoisted_108 = { key: 5 }
const _hoisted_109 = { class: "overflow-hidden table-ellipsis" }
const _hoisted_110 = { class: "inline" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "flex-shrink-0" }
const _hoisted_113 = {
  key: 0,
  class: "card-footer-actions bottom-7 bg-white h-14 flex justify-between items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_114 = { class: "flex items-center text-sm ml-5" }
const _hoisted_115 = { class: "flex items-center px-5 mx-5" }
const _hoisted_116 = ["disabled"]
const _hoisted_117 = {
  key: 1,
  class: "card-footer-actions bottom-7 bg-white h-14 flex justify-between items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_118 = { class: "flex items-center text-sm ml-5" }
const _hoisted_119 = { class: "flex items-center px-5 mx-5" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_122 = { class: "flex flex-col h-full" }
const _hoisted_123 = { class: "flex-1 overflow-auto" }
const _hoisted_124 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_125 = { class: "formcontainer flex flex-col" }
const _hoisted_126 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_127 = { class: "w-full" }
const _hoisted_128 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_129 = {
  key: 0,
  class: "error-text"
}
const _hoisted_130 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_131 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_132 = { class: "row flex flex-row w-full upperspacing gap-3" }
const _hoisted_133 = { class: "w-6/12" }
const _hoisted_134 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_135 = {
  key: 0,
  class: "error-text"
}
const _hoisted_136 = { class: "w-6/12" }
const _hoisted_137 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_138 = {
  key: 0,
  class: "error-text"
}
const _hoisted_139 = { class: "row flex flex-row w-full upperspacing gap-3" }
const _hoisted_140 = { class: "w-6/12" }
const _hoisted_141 = { class: "controllabel" }
const _hoisted_142 = ["maxlength", "placeholder"]
const _hoisted_143 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_144 = {
  key: 0,
  class: "error-text"
}
const _hoisted_145 = {
  key: 1,
  class: "error-text"
}
const _hoisted_146 = { class: "w-6/12" }
const _hoisted_147 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_148 = {
  key: 0,
  class: "error-text"
}
const _hoisted_149 = {
  key: 1,
  class: "error-text"
}
const _hoisted_150 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_151 = {
  key: 1,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pl-5 pr-5')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h1", {
                class: _normalizeClass(["title", _ctx.titleLength > 40? 'heading-ellipsis':''])
              }, _toDisplayString(_ctx.presentControlObject.controlTitle), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex", (_ctx.selectedTabIndex == 0 && _ctx.kpisListForPresentControl.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.allRootKpis.length != 0) ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            ((_ctx.selectedTabIndex == 0 && _ctx.kpisListForPresentControl.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.allRootKpis.length != 0))
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8)),
            _cache[29] || (_cache[29] = _createTextVNode(" Filters "))
          ], 2),
          (_ctx.selectedTabIndex == 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(_ctx.showTotalKpisWeightage < 100 && !_ctx.onSelectCheckBox ? 'btnprimary' : 'btndisabled pointer-events-none'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addKPI(_ctx.kpi)))
              }, "Add", 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Tabs, {
            value: _ctx.selectedTabIndex,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabIndex) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_TabList, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_Tab, {
                        key: tab.id,
                        value: tab.id,
                        onClick: ($event: any) => (_ctx.toggleTabs(tab.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_TabPanels, { class: "mt-5" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: tab.id,
                      value: tab.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          (tab.id == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("table", _hoisted_15, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_16, [
                                        _createElementVNode("th", _hoisted_17, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            name: "checkbox",
                                            class: "checkbox cursor-pointer",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selecteAllActiveKpis) = $event)),
                                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deSelectKpis(0,$event))),
                                            disabled: _ctx.sortedAppliedKpisData.length==0
                                          }, null, 40, _hoisted_18), [
                                            [_vModelCheckbox, _ctx.selecteAllActiveKpis]
                                          ])
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (column) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            scope: "col",
                                            key: column,
                                            class: _normalizeClass(["bg-white cursor-pointer capitalize", _ctx.getColumnHeadWidth(column)]),
                                            onClick: ($event: any) => (_ctx.sort(column))
                                          }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex", _ctx.widthOfColumns(column)])
                                              }, [
                                                (column == 'description')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "KPI Name"))
                                                  : (column == 'weightage')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, "weightage (%)"))
                                                    : (column == 'target')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "target"))
                                                      : (column == 'targetType')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Target Type"))
                                                        : (column == 'kpiCondition')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Condition"))
                                                          : (column == 'kpiType')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Type"))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(column), 1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == column && (_ctx.selectedTabIndex == 0 && _ctx.kpisListForPresentControl.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.allRootKpis.length != 0) ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ], 2)
                                            ])
                                          ], 10, _hoisted_19))
                                        }), 128))
                                      ]),
                                      (_ctx.showFilters)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                                            _cache[30] || (_cache[30] = _createElementVNode("td", null, null, -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (name) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "bg-white",
                                                key: name
                                              }, [
                                                (name == 'targetTimePeriod' || name == 'reportingFrequency')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 0,
                                                      class: "inputboxstyling resize",
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                    }, [
                                                      _createElementVNode("option", {
                                                        value: _ctx.filters.name,
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", 8, _hoisted_29),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlRecurringArray, (value, index) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: index,
                                                          value: value.id
                                                        }, _toDisplayString(value.label), 9, _hoisted_30))
                                                      }), 128))
                                                    ], 8, _hoisted_28)), [
                                                      [_vModelSelect, _ctx.filters[name]]
                                                    ])
                                                  : _createCommentVNode("", true),
                                                (name == 'kpiType')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 1,
                                                      class: _normalizeClass(["inputboxstyling resize", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                    }, [
                                                      _createElementVNode("option", {
                                                        value: _ctx.filters.name,
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", 8, _hoisted_32),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiTypeOptions, (value, index) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: index,
                                                          value: value.id
                                                        }, _toDisplayString(value.name), 9, _hoisted_33))
                                                      }), 128))
                                                    ], 10, _hoisted_31)), [
                                                      [_vModelSelect, _ctx.filters[name]]
                                                    ])
                                                  : (name == 'weightage' || name == 'target' || name == 'targetType' || name == 'kpiCondition')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 3,
                                                        type: "text",
                                                        class: "searchForInputBoxStyling",
                                                        placeholder: "Search",
                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                      }, null, 8, _hoisted_35)), [
                                                        [_vModelText, _ctx.filters[name]]
                                                      ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.loadData == true)
                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
                                          _createElementVNode("tr", _hoisted_37, [
                                            _createElementVNode("td", {
                                              class: "relative h-5",
                                              colspan: _ctx.tableHeads.size
                                            }, [
                                              _createElementVNode("div", _hoisted_39, [
                                                _createVNode(_component_dots_loader)
                                              ])
                                            ], 8, _hoisted_38)
                                          ])
                                        ]))
                                      : (_ctx.columnObject || _ctx.sortedAppliedKpisData.length === 0)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                                            _createElementVNode("tr", _hoisted_41, [
                                              _createElementVNode("td", {
                                                class: "relative h-10",
                                                colspan: _ctx.tableHeads.length
                                              }, _cache[31] || (_cache[31] = [
                                                _createElementVNode("div", { class: "flex justify-center" }, [
                                                  _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                ], -1)
                                              ]), 8, _hoisted_42)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_43, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAppliedKpisData, (kpiData, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: kpiData._id,
                                                class: _normalizeClass(index % 2 == 0 ? 'odd' : 'even')
                                              }, [
                                                _createElementVNode("td", null, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "checkbox",
                                                    name: "checkbox",
                                                    class: "checkbox cursor-pointer",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkedActiveKpis) = $event)),
                                                    onChange: ($event: any) => (_ctx.changedActiveKpiInput(0, $event, kpiData.weightage)),
                                                    value: kpiData._id
                                                  }, null, 40, _hoisted_44), [
                                                    [_vModelCheckbox, _ctx.checkedActiveKpis]
                                                  ])
                                                ]),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (column) => {
                                                  return (_openBlock(), _createElementBlock("td", {
                                                    key: column,
                                                    onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doFalse())),
                                                    onClick: ($event: any) => (_ctx.showEditPopUp(kpiData)),
                                                    class: "whitespace-nowrap cursor-pointer relative"
                                                  }, [
                                                    (column == 'targetTimePeriod' || column == 'reportingFrequency')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                          _createElementVNode("div", _hoisted_47, [
                                                            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.controlRecurringArray.find((itemOne) => {
																		return itemOne.id == kpiData[column];
																	}).label), 1)
                                                          ])
                                                        ]))
                                                      : (column == 'kpiType')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                            (kpiData.kpiType == 3)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Custom"))
                                                              : (kpiData.kpiType == 2)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Optional"))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_52, "N/A"))
                                                          ]))
                                                        : (column == 'weightage')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                              _createElementVNode("div", _hoisted_54, _toDisplayString(kpiData[column]), 1)
                                                            ]))
                                                          : (column == 'target')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.formatKpiTargetForDisplay(kpiData)), 1)
                                                              ]))
                                                            : (column == 'targetType')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.getTargetTypeLabel(kpiData.targetType)), 1)
                                                                ]))
                                                              : (column == 'kpiCondition')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                                    _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.getKpiConditionLabel(kpiData.kpiCondition || kpiData.targetOperator || kpiData.logic)), 1)
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                                    _createElementVNode("div", _hoisted_62, [
                                                                      _createElementVNode("div", _hoisted_63, _toDisplayString(kpiData[column]), 1)
                                                                    ])
                                                                  ]))
                                                  ], 40, _hoisted_45))
                                                }), 128))
                                              ], 2))
                                            }), 128))
                                          ]))
                                  ]),
                                  (_ctx.sortedAppliedKpisData.length != 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _createVNode(_component_pagination, {
                                          dynamicPagination: _ctx.dynamicPagination,
                                          onCurrentPageUpdate: _ctx.paginationUpdations,
                                          sortedData: _ctx.sortedAppliedKpisData
                                        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("table", _hoisted_67, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_68, [
                                        (_ctx.allRootKpis.length != 0)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_69, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                name: "checkbox",
                                                class: "checkbox cursor-pointer",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selecteAllRelatedKpis) = $event)),
                                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectKpis(1,$event)))
                                              }, null, 544), [
                                                [_vModelCheckbox, _ctx.selecteAllRelatedKpis]
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (column) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            scope: "col",
                                            key: column,
                                            class: _normalizeClass(["bg-white cursor-pointer capitalize", _ctx.getColumnHeadWidth(column)]),
                                            onClick: ($event: any) => (_ctx.sort(column))
                                          }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex", _ctx.widthOfColumns(column)])
                                              }, [
                                                (column == 'description')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, "KPI Name"))
                                                  : (column == 'weightage')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, "weightage (%)"))
                                                    : (column == 'target')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, "target"))
                                                      : (column == 'targetType')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, "Target Type"))
                                                        : (column == 'kpiCondition')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, "Condition"))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(column), 1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == column && (_ctx.selectedTabIndex == 0 && _ctx.kpisListForPresentControl.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.allRootKpis.length != 0) ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ], 2)
                                            ])
                                          ], 10, _hoisted_70))
                                        }), 128))
                                      ]),
                                      (_ctx.showFilters)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_77, [
                                            (_ctx.allRootKpis.length != 0)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_78))
                                              : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (name) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "bg-white",
                                                key: name
                                              }, [
                                                (name == 'targetTimePeriod' || name == 'reportingFrequency')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 0,
                                                      class: "inputboxstyling resize",
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                    }, [
                                                      _createElementVNode("option", {
                                                        value: _ctx.filters.name,
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", 8, _hoisted_80),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlRecurringArray, (value, index) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: index,
                                                          value: value.id
                                                        }, _toDisplayString(value.label), 9, _hoisted_81))
                                                      }), 128))
                                                    ], 8, _hoisted_79)), [
                                                      [_vModelSelect, _ctx.filters[name]]
                                                    ])
                                                  : _createCommentVNode("", true),
                                                (name == 'kpiType')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 1,
                                                      class: _normalizeClass(["inputboxstyling resize", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                    }, [
                                                      _createElementVNode("option", {
                                                        value: _ctx.filters.name,
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", 8, _hoisted_83),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiTypeOptions, (value, index) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: index,
                                                          value: value.id
                                                        }, _toDisplayString(value.name), 9, _hoisted_84))
                                                      }), 128))
                                                    ], 10, _hoisted_82)), [
                                                      [_vModelSelect, _ctx.filters[name]]
                                                    ])
                                                  : (name == 'weightage' || name == 'target' || name == 'targetType' || name == 'kpiCondition')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85))
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 3,
                                                        type: "text",
                                                        class: "searchForInputBoxStyling",
                                                        placeholder: "Search",
                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                      }, null, 8, _hoisted_86)), [
                                                        [_vModelText, _ctx.filters[name]]
                                                      ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.loadData == true)
                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_87, [
                                          _createElementVNode("tr", _hoisted_88, [
                                            _createElementVNode("td", {
                                              class: "flex items-center justify-center relative h-5",
                                              colspan: _ctx.tableHeads.size
                                            }, [
                                              _createElementVNode("div", _hoisted_90, [
                                                _createVNode(_component_dots_loader)
                                              ])
                                            ], 8, _hoisted_89)
                                          ])
                                        ]))
                                      : (_ctx.columnObject || _ctx.sortedData.length === 0)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_91, [
                                            _createElementVNode("tr", _hoisted_92, [
                                              _createElementVNode("td", {
                                                class: "relative h-10",
                                                colspan: _ctx.tableHeads.length
                                              }, _cache[32] || (_cache[32] = [
                                                _createElementVNode("div", { class: "flex justify-center" }, [
                                                  _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                ], -1)
                                              ]), 8, _hoisted_93)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_94, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (kpiData, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: kpiData._id,
                                                class: _normalizeClass(index % 2 == 0 ? 'odd' : 'even')
                                              }, [
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("div", _hoisted_95, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "checkbox",
                                                      name: "checkbox",
                                                      class: "checkbox cursor-pointer",
                                                      value: kpiData,
                                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedRootKpis) = $event)),
                                                      onChange: ($event: any) => (_ctx.calculateWeightAge(1, $event, kpiData.weightage))
                                                    }, null, 40, _hoisted_96), [
                                                      [_vModelCheckbox, _ctx.selectedRootKpis]
                                                    ])
                                                  ])
                                                ]),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeads, (column) => {
                                                  return (_openBlock(), _createElementBlock("td", {
                                                    key: column,
                                                    onMouseout: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doFalse())),
                                                    class: "whitespace-nowrap cursor-pointer relative"
                                                  }, [
                                                    (column == 'targetTimePeriod' || column == 'reportingFrequency')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                          _createElementVNode("div", _hoisted_98, [
                                                            _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.controlRecurringArray.find((itemOne) => {
																		return itemOne.id == kpiData[column];
																	}).label), 1)
                                                          ])
                                                        ]))
                                                      : (column == 'weightage')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                            _createElementVNode("div", _hoisted_101, _toDisplayString(kpiData[column]), 1)
                                                          ]))
                                                        : (column == 'target')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                              _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.formatKpiTargetForDisplay(kpiData)), 1)
                                                            ]))
                                                          : (column == 'targetType')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                                _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.getTargetTypeLabel(kpiData.targetType)), 1)
                                                              ]))
                                                            : (column == 'kpiCondition')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                                  _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.getKpiConditionLabel(kpiData.kpiCondition || kpiData.targetOperator || kpiData.logic)), 1)
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                                  _createElementVNode("div", _hoisted_109, [
                                                                    _createElementVNode("div", _hoisted_110, _toDisplayString(kpiData[column]), 1)
                                                                  ])
                                                                ]))
                                                  ], 32))
                                                }), 128))
                                              ], 2))
                                            }), 128))
                                          ]))
                                  ]),
                                  (_ctx.sortedData.length != 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                        (!_ctx.columnObject)
                                          ? (_openBlock(), _createBlock(_component_pagination, {
                                              key: 0,
                                              dynamicPagination: _ctx.dynamicPagination,
                                              onCurrentPageUpdate: _ctx.paginationUpdations,
                                              sortedData: _ctx.sortedData
                                            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_112, [
          (_ctx.selectedTabIndex == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, " Total Weightage is: " + _toDisplayString(_ctx.showTotalKpisWeightage) + " % ", 1),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-2", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelActiveKpis()))
                  }, "Cancel", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(_ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'),
                    disabled: _ctx.isButtonDisabled,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveToRelatedKpis(_ctx.checkedActiveKpis,10303)))
                  }, "Save", 10, _hoisted_116)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTabIndex == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                _createElementVNode("div", _hoisted_118, " Total Weightage is: " + _toDisplayString(_ctx.showTotalKpisWeightage) + " % ", 1),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-2", _ctx.selectedRootKpis.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelRelatedKpis()))
                  }, "Cancel", 2),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveToRelatedKpis(_ctx.selectedRootKpis,10301))),
                    disabled: _ctx.isButtonDisabled,
                    class: _normalizeClass(_ctx.selectedRootKpis.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none')
                  }, "Save", 10, _hoisted_120)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_121, [
                _cache[34] || (_cache[34] = _createElementVNode("h1", { class: "pl-2" }, "Manage KPI", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => {
								_ctx.onCancelbtn();
								_ctx.showPopup = false;
							})
                }, _cache[33] || (_cache[33] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("div", _hoisted_127, [
                                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "KPI Name", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling h-20 max-h-48", {
													'is-invalid': _ctx.v$.addingKpiObj.description.$error || _ctx.isDuplicateData.description
												}]),
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addingKpiObj.description) = $event)),
                                  onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.addingKpiObj.description.$touch())),
                                  placeholder: "KPI Name"
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.description.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                      (_ctx.v$.addingKpiObj.description.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, "Required"))
                                        : (_ctx.v$.addingKpiObj.description.required && _ctx.v$.addingKpiObj.description.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_130, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isDuplicateData.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, _cache[35] || (_cache[35] = [
                                      _createElementVNode("div", { class: "error-text text-xs" }, "KPI Name already exists.", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("div", _hoisted_133, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "Target Type", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.addingKpiObj.targetType,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addingKpiObj.targetType) = $event)),
                                  options: _ctx.targetTypeOptions,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  placeholder: "Please select the option",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.addingKpiObj.targetType.$error }]),
                                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.targetGreaterThanZero(_ctx.addingKpiObj.target)))
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.addingKpiObj.targetType.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                      (_ctx.v$.addingKpiObj.targetType.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_135, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_136, [
                                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "controllabel" }, "Condition", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.addingKpiObj.kpiCondition,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addingKpiObj.kpiCondition) = $event)),
                                  options: _ctx.kpiConditionOptions,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  placeholder: "Please select the option",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.addingKpiObj.kpiCondition.$error }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.addingKpiObj.kpiCondition.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                      (_ctx.v$.addingKpiObj.kpiCondition.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_139, [
                              _createElementVNode("div", _hoisted_140, [
                                _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target' : 'Target(%)'), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': _ctx.v$.addingKpiObj.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero,
												}]),
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addingKpiObj.target) = $event)),
                                  maxlength: _ctx.addingKpiObj.targetType === 'number' ? 10 : 3,
                                  ref: "editTarget",
                                  placeholder: _ctx.addingKpiObj.targetType === 'number' ? 'Target' : 'Target (%)',
                                  onKeyup: _cache[22] || (_cache[22] = ($event: any) => {_ctx.targetLessThanZero(_ctx.addingKpiObj.target); _ctx.targetGreaterThanZero(_ctx.addingKpiObj.target); _ctx.handleTargetInput})
                                }, null, 42, _hoisted_142), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.target,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                      (_ctx.v$.addingKpiObj.target.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target is required' : 'Target (%) is required'), 1))
                                        : _createCommentVNode("", true),
                                      ((_ctx.validTargetError && !_ctx.v$.addingKpiObj.target.required.$invalid) || (_ctx.targetNumberLessThanZero == true && !_ctx.v$.addingKpiObj.target.required.$invalid))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target is Invalid' : 'Target(%) is Invalid'), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_146, [
                                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Weightage (%)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.addingKpiObj.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero,
												}]),
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addingKpiObj.weightage) = $event)),
                                  maxlength: "3",
                                  ref: "editWeight",
                                  placeholder: "Weightage (%)",
                                  onKeyup: _cache[24] || (_cache[24] = ($event: any) => (_ctx.weightageLessThanZero(_ctx.addingKpiObj.weightage) || _ctx.weightageGreaterThanZero(_ctx.addingKpiObj) && _ctx.handleInput))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.weightage,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                      (_ctx.v$.addingKpiObj.weightage.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, " Weightage (%) is required "))
                                        : _createCommentVNode("", true),
                                      ((_ctx.validtaionWeightageError && !_ctx.v$.addingKpiObj.weightage.required.$invalid) || (_ctx.numberLessThanZero == true && !_ctx.v$.addingKpiObj.weightage.required.$invalid))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, " Weightage(%) is Invalid "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  (_ctx.addingKpiObj._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onCancelbtn()))
                        }, "Cancel", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.addOrUpdateKpiForControlManual(_ctx.addingKpiObj)))
                        }, "Save", 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_151, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary']),
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelbtn()))
                        }, "Cancel", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(_ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'),
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.addOrUpdateKpiForControlManual(_ctx.addingKpiObj)))
                        }, "Save", 2)
                      ]))
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}